import { Mail, MessageCircle, Phone, Send } from 'lucide-react';
import { Input } from '../../../components';
import type { ChannelKind } from '../hooks/useLeadForm';

export interface ChannelInputProps {
  kind: ChannelKind;
  visible: boolean;
  value: string;
  onChange: (raw: string) => void;
  error?: string;
}

const ICONS: Record<ChannelKind, typeof Send> = {
  telegram: Send,
  whatsapp: MessageCircle,
  phone: Phone,
  email: Mail,
};

const META: Record<ChannelKind, { placeholder: string; label: string; type: string; inputMode?: 'tel' | 'email' | 'text' }> = {
  telegram: { placeholder: '@username или https://t.me/username', label: 'Telegram', type: 'text', inputMode: 'text' },
  whatsapp: { placeholder: '+998 90 123 45 67', label: 'WhatsApp', type: 'tel', inputMode: 'tel' },
  phone: { placeholder: '+998 90 123 45 67', label: 'Телефон', type: 'tel', inputMode: 'tel' },
  email: { placeholder: 'you@example.com', label: 'Email', type: 'email', inputMode: 'email' },
};

export default function ChannelInput({ kind, visible, value, onChange, error }: ChannelInputProps) {
  const Icon = ICONS[kind];
  const meta = META[kind];
  return (
    <div
      className={['lead-form__field', `lead-form__field--${kind}`, visible ? 'lead-form__field--visible' : ''].filter(Boolean).join(' ')}
      aria-hidden={!visible}
    >
      <Input
        label={meta.label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={meta.placeholder}
        type={meta.type}
        inputMode={meta.inputMode}
        iconLeft={<Icon size={16} />}
        error={visible ? error : undefined}
        tabIndex={visible ? 0 : -1}
        autoComplete="off"
      />
    </div>
  );
}
